import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faPlus } from "@fortawesome/free-solid-svg-icons";
import DashboardHeader from "../components/Other/DashboardHeader";
import PageHeaderTitle from "../components/pages/PageHeaderTitle";
import PageContainer from "../components/pages/PageContainer";
import {
  getProfile,
  updateProfile,
  s3Upload,
  tradingType,
  checkUsername,
  getCountries,
} from "../api/user";
import { useNavigate, useOutletContext } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import Loader from "../components/Loader";
import { event } from "../utils/event";
import { SUBSCRIPTION_ENABLED } from "../utils/utils";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const EditProfile = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [sidebarToggle] = useOutletContext();
  const flutterView = localStorage.getItem("isFlutterInAppWebViewReady");
  const token = localStorage.getItem("accessToken");
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [countryCode, setcountryCode] = useState("");
  const [phone, setPhoneNumber] = useState("");
  const [tradingStyle, setTrading] = useState("");
  const [chatType, setChat] = useState("");
  const [imgurl, setImgUrls] = useState([]);
  const [images, setImages] = useState([]);
  const [subscriptionPlanAmount, setSubscriptionPlanAmount] = useState("");
  const [bio, setBio] = useState("");
  const [title, setTitle] = useState("");
  const [username, setUsername] = useState("");
  const [username1, setUsername1] = useState("");
  const [link, setLink] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const imageInputRef = useRef(null);
  const [userNameError, setUserNameError] = useState("");
  const [trading, setTrade] = useState([]);

  const [date_of_birth, setDob] = useState("");
  const [maxDate, setMaxDate] = useState('');

  const [country_of_origin, setCountry] = useState([]);
  const [countries, setCountries] = useState([]);
  const [inputsStatus, setInputsStatus] = useState({
    name: "",
    email: "",
    phone: "",
    countryCode: "",
    titile: "",
    link: "",
    bio: "",
    countryCode: "",
    tradingStyle: "",
    subscriptionPlanAmount,
    username: "",
    date_of_birth:"",
    country_of_origin:"",
  });
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isDataFeteched1, setisDataFeteched1] = useState(false);
  const numberMatch = /^\d+(\.\d+)?$/;
  const emailPattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,10}$/g;
  const userinfo = JSON.parse(localStorage.getItem("userInfo"));

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("userInfo"));
    fetchProfile(user);
  }, []);

  useEffect(() => {
    if (!isDataFeteched1) fetchTrading();
  }, [isDataFeteched1]);


  useEffect(() => {
    // Prevent selecting future dates (only allow 13+ years old)
    const today = new Date();
    today.setFullYear(today.getFullYear() - 13);
    setMaxDate(today);
  }, []);

  // ✅ Convert Date object to MM-DD-YYYY for display
  const formatDateForDisplay = (date) => {
    if (!date) return "";
    const month = String(date.getMonth() + 1).padStart(2, "0"); // MM
    const day = String(date.getDate()).padStart(2, "0"); // DD
    const year = date.getFullYear(); // YYYY
    return `${month}-${day}-${year}`;
  };

  // ✅ Convert Date object to YYYY-MM-DD for backend (Without UTC Shift)
  const formatDateForBackend = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // MM
    const day = String(date.getDate()).padStart(2, "0"); // DD
    return `${year}-${month}-${day}`; // Stores YYYY-MM-DD (Correct format)
  };

  // ✅ Handle date selection (Prevent timezone shift)
  const handleDateChange = (date) => {
    if (date) {
      const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate()); // Removes UTC shift
      setDob(localDate);
    } else {
      setDob(null);
    }
  };

  const fetchProfile = async (user) => {
    const profileData = user;
    console.log(profileData, 'profile data is');
    setFullname(profileData.full_name || "");
    setEmail(profileData.email || "");
    setPhoneNumber(profileData.phone || "");
    setcountryCode(profileData.country_code || "");
    setTrading(profileData.trading_type_id || "");
    setTitle(profileData.title || "");
    setSubscriptionPlanAmount(profileData?.subscription_plan_amount);
    setBio(profileData.biography || "");
    setProfileImage({
      src: profileData.image,
      blob: null,
    });
    // setCountryCode({
    //   countryCode: profileData.country_code || "",
    // });
    setChat(profileData.is_chat_paid);
    setLink(profileData.link);
    setUsername(profileData.user_name);
    setUsername1(profileData.user_name);
        // setDob(profileData.date_of_birth); // Store backend format
    if (profileData.date_of_birth) {
      let parsedDate;

      if (profileData.date_of_birth.includes("T")) {
        // Format: "YYYY-MM-DDTHH:mm:ss.sssZ" → Convert to Date object
        parsedDate = new Date(profileData.date_of_birth);
      } else {
        // Format: "YYYY-MM-DD" → Manually split and create Date object
        const [year, month, day] = profileData.date_of_birth.split("-").map(Number);
        parsedDate = new Date(year, month - 1, day);
      }

      setDob(parsedDate);
    }

    setCountry(profileData.country_of_origin);
  };


  const fetchTrading = async () => {
    try {
      const response = await tradingType();
      if (response?.data?.status == 200) {
        setTrade(response?.data?.data);
        setisDataFeteched1(true);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleImageUpload = async (e) => {
    try {
      setLoading(true);
      const selectedFile = e.target.files[0];
      setProfileImage({
        src: URL.createObjectURL(selectedFile),
        blob: null,
      });
      if (!selectedFile) {
        console.error("No file selected for upload.");
        return;
      }

      const newImage = {
        id: null,
        image: null,
        blob: selectedFile,
        preview: URL.createObjectURL(selectedFile),
      };
      setImages([newImage]);
      const response = await s3Upload([newImage]);
      if (response && response.data && response.data.data) {
        const imagePath = response.data.data[0];
        setImgUrls(imagePath);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    const handleFlutterEvent = (event) => {
      const handleCustomProfileEvent = (event) => {
        const baseUrl = userinfo?.s3_url;
        setImgUrls(event?.detail?.image);
        setProfileImage({ src: baseUrl + event?.detail?.image });
      };
      window.addEventListener("myCustomProfileEvent", handleCustomProfileEvent);
    };

    window.addEventListener("flutterEvent", handleFlutterEvent);
    return () => window.removeEventListener("flutterEvent", handleFlutterEvent);
  }, [window.addEventListener, localStorage]);

  const handleUpdateProfile = async () => {
    try {
      if (!fullname) {
        toast.error("Name is Required");
        return;
      } else if (fullname.length > 40) {
        toast.error("Name must not exceed 40 characters");
        return;
      } else if (title.length > 50) {
        toast.error("Title must not exceed 50 characters");
        return;
      } else if (bio.length > 250) {
        toast.error("Bio must not exceed 250 characters");
        return;
      }
      if (!tradingStyle) {
        toast.error("Trading Style is Required");
        return;
      }
      if (
        subscriptionPlanAmount &&
        !subscriptionPlanAmount.match(numberMatch)
      ) {
        toast.error("Subscription Amount should contain positive number only");
        return;
      }
      if (userNameError) {
        return;
      }
      if (!username) {
        toast.error("Trader name is required!");
        return;
      }
      if (username.length > 20) {
        toast.error("Trader name length should not be greater than 20!");
        return;
      }
      // if(!date_of_birth){
      //   toast.error("Date of birth is required!");
      //   return;
      // }
      // if(!country_of_origin){
      //   toast.error("Country is required!");
      //   return;
      // }
      if (phone && phone.length < 10) {
          toast.error("Phone number must be 10 digits!");
          return;
      }


    // console.log(country_of_origin,'country is');

      setLoading(true);

      const dataTrading =
        trading && trading.length > 0 && trading.map((val) => val?.id);

      const tradingStyle1 = tradingStyle && parseInt(tradingStyle);

      const response = await updateProfile({
        full_name: fullname,
        email: email,
        countryCode: "+1",
        phone: phone,
        countryCode:countryCode,
        title: title,
        link: link,
        biography: bio,
        image: imgurl,
        trading_type_id:
          dataTrading && dataTrading.includes(tradingStyle1)
            ? tradingStyle
            : trading[0]?.id,
        subscription_plan_amount: subscriptionPlanAmount,
        chat_type: chatType,
        user_name: username,
        date_of_birth: date_of_birth ? formatDateForBackend(date_of_birth) : null,
        country_of_origin:country_of_origin ? Number(country_of_origin) : null
      });
      if (response.data.status === 200) {
        localStorage.setItem("userInfo", JSON.stringify(response.data.data));
        localStorage.removeItem("img");
        localStorage.removeItem("image");
        toast.success(response.data.message);
        navigate("/profile");
        setLoading(false);
      } else if (response.data.status === 400) {
        setLoading(false);
        toast.error(response.data.message);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error.response.data.message);
      console.error("Error:", error);
    }
  };
  useEffect(() => {
    if (email.length > 0) {
      setInputsStatus({
        ...inputsStatus,
        email: email.match(emailPattern) ? "valid" : "invalid",
      });
    }
  }, [email]);


  useEffect(() => {

      const fetchCountries = async () => {
    try {
      const response = await getCountries();

      // Ensure the correct part of the response is used
      if (response.data && response.data.success) {
        setCountries(response.data.data); // Use `response.data.data` to set the countries
      } else {
        console.error("Failed to fetch countries:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };

  fetchCountries();

  }, []);


  useEffect(() => {
    if (subscriptionPlanAmount && subscriptionPlanAmount.length > 0) {
      setInputsStatus({
        ...inputsStatus,
        subscriptionPlanAmount: subscriptionPlanAmount.match(numberMatch)
          ? "valid"
          : "invalid",
      });
    }
  }, [subscriptionPlanAmount]);

  const handleChange = async (e) => {
    e.preventDefault();
    setUserNameError("");
    const userName = e.target.value;
    setUsername(e.target.value);
    if (userName.trim() != username1.trim()) {
      try {
        const response = await checkUsername({ user_name: userName });
        if (response?.data?.data.length > 0) {
          setUserNameError(response?.data?.message);
        } else {
          setUserNameError("");
        }
      } catch (error) {
        console.error("Error:", error);
        setUserNameError("");
      }
    }
  };
  return (
    <>
      <DashboardHeader toggle={sidebarToggle} />
      <PageHeaderTitle title={t("Edit Profile")} />
      {loader ? (
        <Loader dark />
      ) : (
        <PageContainer>
          <div className="px-4" style={{ zoom: "80%" }}>
            <div className="mx-auto w-32 mb-16 mt-4">
              {loading ? (
                // Show loader while uploading
                <Loader />
              ) : (
                !loading && (
                  <>
                    {flutterView ? (
                      <>
                        <button
                          type="button"
                          onClick={() => imageInputRef?.current?.click()}
                          className="z-[1] text-white bg-emerald-700 ml-20 md:mt-[-5px] mt-8 top-0 right-2 text-sm rounded-full px-2 block aspect-square transition-all"
                        >
                          <FontAwesomeIcon
                            icon={
                              profileImage !== null ? faPenToSquare : faPlus
                            }
                          />
                        </button>
                        <img
                          src={profileImage?.src}
                          className="object-cover w-full border-4 border-gray-50/50 h-auto aspect-square mx-auto rounded-full"
                          alt=""
                        />
                        <input
                          type="file"
                          ref={imageInputRef}
                          className="hidden"
                          name="image"
                          id="upload"
                          accept="image/*"
                          multiple
                          onChange={handleImageUpload}
                        />
                      </>
                    ) : (
                      <>
                        {/* Your existing JSX code without the condition */}
                        <button
                          type="button"
                          onClick={() => imageInputRef?.current?.click()}
                          className="z-[1] text-white bg-emerald-700 ml-20 md:mt-[-5px] mt-8 top-0 right-2 text-sm rounded-full px-2 block aspect-square transition-all"
                        >
                          <FontAwesomeIcon
                            icon={
                              profileImage !== null ? faPenToSquare : faPlus
                            }
                          />
                        </button>
                        <img
                          src={profileImage?.src}
                          className="object-cover w-full border-4 border-gray-50/50 h-auto aspect-square mx-auto rounded-full"
                          alt=""
                        />
                        <input
                          type="file"
                          ref={imageInputRef}
                          className="hidden"
                          name="image"
                          id="upload"
                          accept="image/*"
                          multiple
                          onChange={handleImageUpload}
                        />
                      </>
                    )}
                  </>
                )
              )}
            </div>
            <div className="max-w-screen-md mx-auto mt-10 space-y-5">
              <div className=" w-32 mx-auto mb-16">{/* ... (unchanged) */}</div>
              <div className="md:flex md:gap-5">
                <div className=" w-full md:w-1/2">
                  <input
                    type="text"
                    className={`border-2 px-2 py-2 rounded-lg w-full ${
                      inputsStatus.full_name === "invalid" &&
                      "border-2 !border-red-500"
                    }`}
                    placeholder={t("Full name")}
                    value={fullname}
                    onChange={(e) => setFullname(e.target.value)}
                    required // HTML5 required attribute
                  />
                  <span className="absolute right-0 top-0 transform -translate-y-1/2 text-primaryColor">
                    *
                  </span>
                </div>
                <div className=" w-full md:w-1/2 mt-2 md:mt-0">
                  <input
                    type="email"
                    className={`border-2 px-2 py-2 rounded-lg w-full ${
                      inputsStatus.email === "invalid" &&
                      "border-2 !border-red-500"
                    }`}
                    placeholder={t("Email")}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required // HTML5 required attribute
                  />
                  <span className="absolute right-0 top-0 transform -translate-y-1/2 text-primaryColor">
                    *
                  </span>
                </div>
              </div>

              <input
                type="text"
                placeholder={t("Title")}
                className={`border-2 px-2 py-2 rounded-lg w-full ${
                  inputsStatus.titile === "invalid" &&
                  "border-2 !border-red-500"
                }`}
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />


      {/* Custom Input Field for MM-DD-YYYY Display */}

    <div className="flex flex-col mb-4 ">
<div className="relative">
      <DatePicker
        selected={date_of_birth}
        onChange={handleDateChange}
        dateFormat="MM-dd-yyyy" // Ensure MM-DD-YYYY format
        placeholderText="MM-DD-YYYY"
        maxDate={maxDate} // Prevents selecting future dates
        showYearDropdown // Allows year selection
        scrollableYearDropdown // Allows scrolling through years
        yearDropdownItemNumber={100} // Shows 100 years in dropdown
        showMonthDropdown // Allows month selection
        className="border px-3 py-2 rounded-lg !w-full"
      />
    </div>
</div>


              {/* <select
                value={country_of_origin}
                onChange={(e) => setCountry(e.target.value)}
                className={`border-2 px-2 py-2 rounded-lg w-full ${
                  inputsStatus.country === "invalid" && "border-2 !border-red-500"
                }`}
              >
                <option value="" disabled>
                  {t("Select Country of Origin")}
                </option>
                {countries.map((country) => (
                  <option key={country.id} value={country.id}>
                    {country.name}
                  </option>
                ))}
              </select> */}

<select
  value={country_of_origin}
  onChange={(e) => setCountry(e.target.value)}
  className={`border-2 px-2 py-2 rounded-lg w-full ${
    inputsStatus.country === "invalid" && "border-2 !border-red-500"
  }`}
>
  <option value="" disabled>
    {t("Select Country of Origin")}
  </option>

  {/* Sort countries while keeping the selected value intact */}
  {[
    ...countries.filter((c) => c.id === country_of_origin), // Preserve selected country (if any)
    ...countries.filter((c) => c.name === "United States" && c.id !== country_of_origin), // Move "India" to top if it's not selected
    ...countries.filter((c) => c.name !== "United States" && c.id !== country_of_origin), // Add the rest of the countries
  ].map((country) => (
    <option key={country.id} value={country.id}>
      {country.name}
    </option>
  ))}
</select>


              {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-5"> */}
                {/* <input
                  type="text"
                  className={`border-2 px-2 py-2 rounded-lg w-full ${
                    inputsStatus.countryCode === "invalid" &&
                    "border-2 !border-red-500"
                  }`}
                  placeholder={t("Country Code")}
                  value={countryCode}
                  onChange={(e) => setcountryCode(e.target.value)}

                /> */}

<input
  type="tel"
  className={`border-2 px-2 py-2 rounded-lg w-full ${
    inputsStatus.phone === "invalid" ? "!border-red-500" : "border-gray-300"
  }`}
  placeholder={t("Phone Number")}
  value={phone}
  onChange={(e) =>
    setPhoneNumber(
      e.target.value.replace(/[^\d\s\-()+]/g, "").slice(0, 20) // Allow only digits, spaces, +, -, (, )
    )
  }
  maxLength={20} // Limit input to 20 characters
/>


              {/* </div> */}


              <input
                type="text"
                placeholder={"Trader name"}
                className={`border-2 px-2 py-2 rounded-lg w-full ${
                  inputsStatus.titile === "invalid" &&
                  "border-2 !border-red-500"
                }`}
                value={username}
                onChange={handleChange}
              />
              <span
                style={{
                  color: "red",
                }}
                className="text-[12px]"
              >
                {userNameError}
              </span>
              <div className="grid grid-cols-1 gap-5">
                <select
                  className={`w-full border-2 px-2 py-2 border-gray-300 rounded-lg ${
                    inputsStatus.tradingStyle === "invalid"
                      ? "border-2 border-red-500"
                      : ""
                  }`}
                  value={tradingStyle}
                  onChange={(e) => setTrading(e.target.value)}
                >
                  <option value="" disabled>
                    {t("Select Trading Style")}
                  </option>
                  {trading.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.type}
                    </option>
                  ))}
                </select>{" "}
                {SUBSCRIPTION_ENABLED ? (
                  <div className="relative flex items-center w-full">
                    <span className="absolute ml-5 mt-2.5 mb-[10px] text-lg text-black">
                      $
                    </span>
                    <input
                      type="text"
                      maxLength="6"
                      placeholder={t("Subscription Amount (In USD)")}
                      className={`border-2 px-2 py-2 rounded-lg pl-8 w-full ${
                        inputsStatus.subscriptionPlanAmount === "invalid"
                          ? "border-2 border-red-500"
                          : "border"
                      }`}
                      value={subscriptionPlanAmount}
                      onChange={(e) => {
                        const input = e.target.value;
                        const regex = /^\d*\.?\d{0,2}$/; // Regex to allow only digits and up to 2 decimal places
                        if (regex.test(input)) {
                          setSubscriptionPlanAmount(input);
                        }
                      }}
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
              <textarea
                placeholder={t("Bio")}
                rows={3}
                className={` w-full ${
                  inputsStatus.bio === "invalid"
                    ? "border-2 border-red-500"
                    : "border border-gray-300"
                } rounded-lg px-2 py-3 mt-2 border-2`}
                value={bio}
                onChange={(e) => setBio(e.target.value)}
              />
              <input
                type="text"
                placeholder={t("Social Link")}
                className={`border-2 px-2 py-2 rounded-lg w-full ${
                  inputsStatus.link === "invalid" && "border-red-500"
                }`}
                value={link !== "null" || null ? link : ""}
                onChange={(e) => setLink(e.target.value)}
              />
              <div></div>
              <div>
                <button
                  onClick={handleUpdateProfile}
                  className="py-2 px-4 mb-24 border border-emerald-500 bg-emerald-900 rounded text-gray-200"
                >
                  {t("Update Profile")}
                </button>
              </div>
            </div>
          </div>
        </PageContainer>
      )}
    </>
  );
};

export default EditProfile;
